import React from 'react'
import CurrencyTypeView from '../../../../../itrust_common/components/others/CurrencyTypeView';

export default function Procedure(props) {
  const { procedures, order } = props

  const getProcedureTotal = (procedures) => {
    let total = 0
    procedures.forEach(procedure => {
      return total = total + procedure.subtotal
    })
    return total
  }

  return (
    <>
      <tr className="text-dark bg-light border-bottom border-white border-bottom-2">
        <td colspan="11"><h6>Exam Procedure</h6></td>
        <td><h6 className="text-danger">{order.cash_procedures_discount ? <CurrencyTypeView amount={order.cash_procedures_discount} /> : ''}</h6></td>
        <td><h6>{getProcedureTotal(procedures) ? <CurrencyTypeView name={getProcedureTotal(procedures)} /> : ''}</h6></td>
      </tr>
      {procedures.map((procedure, index) => (
        <tr key={`procedure-${index}`} className="text-dark bg-light border-bottom border-white border-bottom-2">
          <td colspan='2'>{index + 1}. {procedure.description}</td>
          <td>{procedure.exam_code || ''}</td>
          <td className="pl-8">{procedure.unit_price ? <CurrencyTypeView amount={procedure.unit_price} /> : ''}</td>
          <td>{procedure.copay ? <CurrencyTypeView amount={procedure.copay} /> : ''}</td>
          <td>{(procedure.cash_discount || procedure.percentage_discount) ? <CurrencyTypeView amount={procedure.discount_type === "cash" ? procedure.cash_discount : procedure.percentage_discount} /> : ''}</td>
          <td></td>
          <td></td>
          <td> {procedure.coinsurance ? <CurrencyTypeView amount={procedure.coinsurance} /> : ''}</td>
          <td> {procedure.deductible ? <CurrencyTypeView amount={procedure.deductible} /> : ''}</td>
          <td colspan='3'>{procedure.subtotal ? <CurrencyTypeView amount={procedure.subtotal} /> : ''}</td>
        </tr>
      ))}
    </>
  )
}